module.exports = __webpack_public_path__ + "static/media/cms.fbc71eba.svg";